import axios from 'axios'

const GetRequest = (url, data = null) => {
    const  baseUrl = 'https://earsiv-api.faveraportal.com'
    axios.defaults.withCredentials = true;
    const request = axios.get(`${baseUrl}/${url}`, data)

  return request;
};

export default GetRequest;
